<template>
	<div>
		<performance-review-template v-if="template" :template="template" :is-admin="loggedInEmployee.isAdmin" @onEdit="editTemplate" />

		<v-footer color app height="55" class="noPrint">
			<v-spacer></v-spacer>
			<v-btn v-if="loggedInEmployee != null" :disabled="!loggedInEmployee.isAdmin" @click="editTemplate(template.id)" color="primary"> <v-icon class="mr-2">edit</v-icon>Edit Template </v-btn>
		</v-footer>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import PerformanceReviewTemplate from '@/components/performanceReview/PerformanceReviewTemplate';

	export default {
		props: {
			id: {
				required: true
			}
		},
		components: {
			PerformanceReviewTemplate
		},
		data() {
			return {};
		},
		created() {
			this.$store.dispatch('setPageTitle', 'Performance Review Template');
		},
		computed: {
			...mapGetters({
				loggedInEmployee: 'loggedInEmployee'
			}),
			template() {
				return this.$store.state.performanceReviewTemplates.templates.find(template => template.id == this.id);
			}
		},
		methods: {
			editTemplate(id) {
				this.$router.push(`/prTemplate/${id}/edit`);
			}
		}
	};
</script>

<style></style>
